const SheetOneLoader = () => {
  return (
    <div className="w-[600px] bg-white rounded-lg border border-[#e1e6ef] shadow-sm overflow-hidden animate-pulse">
      <table className="w-full border-collapse text-xs">
        <thead>
          <tr>
            <th className="h-8 bg-gray-300 rounded-tl-lg"></th>
            <th colSpan="2" className="h-8 bg-gray-300"></th>
            <th colSpan="2" className="h-8 bg-gray-300 rounded-tr-lg"></th>
          </tr>
          <tr>
            <th className="h-6 bg-gray-200"></th>
            <th className="h-6 bg-gray-200"></th>
            <th className="h-6 bg-gray-200"></th>
            <th className="h-6 bg-gray-200"></th>
            <th className="h-6 bg-gray-200"></th>
          </tr>
        </thead>
        <tbody>
          {[...Array(8)].map((_, idx) => (
            <tr key={idx} className={idx % 2 === 0 ? "bg-gray-100" : ""}>
              {[...Array(5)].map((__, i) => (
                <td key={i} className="p-2">
                  <div className="h-4 bg-gray-300 rounded"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SheetOneLoader;
